// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1787561756548
      var cssReload = require("D:/code/customer/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  